<nav #nav
    class="header-panel navbar navbar-expand-lg fixed-top nav-expand position-absolute headerWhite position-fixed">
    <div class="container">
        <button class="navbar-toggler d-lg-none" type="button" (click)="toggleMenu()"
            [attr.aria-expanded]="!isMenuCollapsed" aria-label="Toggle navigation">
            <i class="fal fa-bars"></i>
        </button>

        <div class="logo-panel">
            <div class="logo pointer-in d-flex" [routerLink]="['/panel-control/events']">
                <img fallimg #imgHeader src="assets/img/citylok_horizontal.svg" alt="Citylok logo">
                <mat-divider [vertical]="true"></mat-divider>
                <div>
                    <p class="m-0">Panel</p>
                    <p class="m-0">De Control</p>
                </div>
            </div>
            <span class="company-name-header d-none d-lg-inline" *ngIf="companySelect?.name">{{companySelect.name}}</span>
        </div>

        <!-- Menú organización (móvil) -->
        <div class="mobile-company-menu d-lg-none">
            <button class="button-menu-panel pointer-in" mat-icon-button disableRipple="false"
                (click)="goEditProfile()">
                <ng-container *ngIf="profile?.image; else mobileTriggerIcon">
                    <img fallimg class="avatar-trigger" [src]="urlImages + profile.image" alt="Avatar user" />
                </ng-container>
                <ng-template #mobileTriggerIcon>
                    <i class="fal fa-user-circle"></i>
                </ng-template>
            </button>
        </div>

        <div class="desktop-menu d-none d-lg-flex">
            <div class="d-flex justify-content-end w-100">
                <div class="d-flex items-menu" *ngIf="!hideDesktopNavigation">
                    <!-- Empresas -->
                    <div class="item-menu item-always-visible" *ngIf="allowSuperAdmin" (click)="activeTab(1, 'Eventos')"
                        [routerLink]="['/panel-control/list-business']" routerLinkActive="item-active"
                        [routerLinkActiveOptions]="{exact:false}">
                        <i class="fal fa-table-tree pointer-in"></i>
                        <p class="m-0">Empresas</p>
                    </div>
                    <!-- Eventos -->
                    <div class="item-menu item-always-visible" (click)="activeTab(1, 'Eventos')" [routerLink]="['/panel-control/events']"
                        routerLinkActive="item-active" [routerLinkActiveOptions]="{exact:false}">
                        <i class="fal fa-calendar-days pointer-in"></i>
                        <p class="m-0">Eventos</p>
                    </div>
                    <!-- Pedidos -->
                    <div class="item-menu item-always-visible" (click)="activeTab(2, 'Pedidos')"
                        [class.item-desactive]="!admin && !allowOrder && !allowSales"
                        [routerLink]="['/panel-control/orders']" routerLinkActive="item-active"
                        [routerLinkActiveOptions]="{exact:false}">
                        <i class="fal fa-square-list pointer-in"></i>
                        <p class="m-0">Pedidos</p>
                    </div>
                    <!-- Usuarios -->
                    <div class="item-menu item-show-1320" (click)="activeTab(3, 'Usuarios')"
                        [routerLink]="['/panel-control/subscribers']" routerLinkActive="item-active"
                        [routerLinkActiveOptions]="{exact:false}" [class.item-desactive]="!admin && !allowMarketing">
                        <i class="fal fa-user-group-simple pointer-in"></i>
                        <p class="m-0">Usuarios</p>
                    </div>
                    <!-- Taquilla (módulo cash_register) -->
                    <div class="item-menu item-show-1440" *ngIf="showCashRegister" (click)="openTicketOffice()" [class.item-desactive]="!admin && !allowSales">
                        <i class="fal fa-ticket pointer-in"></i>
                        <p class="m-0">Taquilla</p>
                    </div>
                    <!-- Informes -->
                    <div class="item-menu item-show-1560" (click)="activeTab(4, 'Informes')"
                        [class.item-desactive]="!admin && !allowOrder && !allowSales"
                        [routerLink]="['/panel-control/reports']">
                        <i class="fal fa-chart-line pointer-in"></i>
                        <p class="m-0">Informes</p>
                    </div>
                    <!-- Descuentos -->
                    <div class="item-menu item-show-1560" (click)="activeTab(5, 'Descuentos')"
                        [class.item-desactive]="!admin && !allowOrder && !allowSales"
                        [routerLink]="['/panel-control/discounts']">
                        <i class="fal fa-percent pointer-in"></i>
                        <p class="m-0">Descuentos</p>
                    </div>
                    <!-- Menú más opciones (solo visible en pantallas medianas) -->
                    <div class="item-menu item-more-menu" [matMenuTriggerFor]="moreMenu">
                        <i class="fal fa-ellipsis pointer-in"></i>
                    </div>
                    <mat-menu #moreMenu="matMenu" class="options-menu-control-panel">
                        <div mat-menu-item class="item-hide-from-1320" (click)="activeTab(3, 'Usuarios')" [routerLink]="['/panel-control/subscribers']"
                            [class.disabled]="!admin && !allowMarketing">
                            <span>Usuarios</span>
                        </div>
                        <div mat-menu-item class="item-hide-from-1440" *ngIf="showCashRegister" (click)="openTicketOffice()" [class.disabled]="!admin && !allowSales">
                            <span>Taquilla</span>
                        </div>
                        <div mat-menu-item class="item-hide-from-1560" (click)="activeTab(4, 'Informes')" [routerLink]="['/panel-control/reports']"
                            [class.disabled]="!admin && !allowOrder && !allowSales">
                            <span>Informes</span>
                        </div>
                        <div mat-menu-item class="item-hide-from-1560" (click)="activeTab(5, 'Descuentos')" [routerLink]="['/panel-control/discounts']"
                            [class.disabled]="!admin && !allowOrder && !allowSales">
                            <span>Descuentos</span>
                        </div>
                        <div mat-menu-item (click)="activeTab(6, 'Abonos')" [routerLink]="['/panel-control/bonds']"
                            [class.disabled]="!admin && !allowSales">
                            <span>Abonos</span>
                        </div>
                    </mat-menu>
                </div>
                <div class="selects-panel">
                    <!-- Mode pill -->
                    <div class="mode-pill me-3">
                        <span class="mode-option" [class.active]="userMode === 'user'" (click)="switchMode('user')">
                            <i class="fal fa-user fa-sm"></i> Usuario
                        </span>
                        <span class="mode-option" [class.active]="userMode === 'organizer'" (click)="switchMode('organizer')">
                            <i class="fal fa-building fa-sm"></i> Gestor
                        </span>
                    </div>
                    <!-- Menú organización -->
                    <div class="item-edit-profile" (click)="goEditProfile()">
                        <div class="img-user-menu" *ngIf="profile?.image; else desktopDefaultAvatar">
                            <img fallimg [src]="urlImages + profile.image" alt="Avatar user" />
                        </div>
                        <ng-template #desktopDefaultAvatar>
                            <div class="img-user-menu img-user-icon">
                                <i class="fal fa-user-circle"></i>
                            </div>
                        </ng-template>
                        <div class="d-grid info-profile-menu">
                            <span class="name-profile">{{profile?.name}}</span>
                            <span>{{profile?.email}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nav>

<!-- Offcanvas menu for mobile -->
<div class="offcanvas offcanvas-start" [class.show]="!isMenuCollapsed" tabindex="-1">
    <div class="offcanvas-header">
        <button type="button" class="btn-close" (click)="toggleMenu()" aria-label="Close">
            <i class="fal fa-times"></i>
        </button>
    </div>
    <div class="offcanvas-body">
        <!-- Perfil -->
        <div class="offcanvas-profile" (click)="goEditProfile(); toggleMenu()">
            <div class="img-user-menu" *ngIf="profile?.image; else offcanvasDefaultAvatar">
                <img fallimg [src]="urlImages + profile.image" alt="Avatar user" />
            </div>
            <ng-template #offcanvasDefaultAvatar>
                <div class="img-user-menu img-user-icon">
                    <i class="fal fa-user-circle"></i>
                </div>
            </ng-template>
            <div class="d-grid info-profile-menu">
                <span class="name-profile">{{profile?.name}}</span>
                <span>{{profile?.email}}</span>
            </div>
        </div>
        <div class="offcanvas-company" *ngIf="companySelect?.name">
            <span class="company-name-header">{{companySelect.name}}</span>
        </div>
        <mat-divider style="margin-bottom: 1rem;"></mat-divider>
        <!-- El mismo selector "Usuario / Gestor" de la barra de escritorio.
             Sin él, en el móvil un gestor no podía pasar a su cuenta de
             usuario (sus entradas, sus abonos): el avatar lleva al perfil de
             la empresa y /profile le devuelve al panel en modo gestor. -->
        <div class="selects-panel">
            <div class="mode-pill">
                <span class="mode-option" [class.active]="userMode === 'user'" (click)="switchMode('user'); toggleMenu()">
                    <i class="fal fa-user fa-sm"></i> Usuario
                </span>
                <span class="mode-option" [class.active]="userMode === 'organizer'" (click)="switchMode('organizer'); toggleMenu()">
                    <i class="fal fa-building fa-sm"></i> Gestor
                </span>
            </div>
        </div>
        <div class="items-menu">
            <!-- Empresas -->
            <div class="item-menu" *ngIf="allowSuperAdmin" (click)="activeTab(1, 'Empresas'); toggleMenu()"
                [routerLink]="['/panel-control/list-business']" routerLinkActive="item-active"
                [routerLinkActiveOptions]="{exact:false}">
                <i class="fal fa-table-tree pointer-in"></i>
                <p class="m-0">Empresas</p>
            </div>
            <!-- Eventos -->
            <div class="item-menu" (click)="activeTab(1, 'Eventos'); toggleMenu()" [routerLink]="['/panel-control/events']"
                routerLinkActive="item-active" [routerLinkActiveOptions]="{exact:false}">
                <i class="fal fa-calendar-days pointer-in"></i>
                <p class="m-0">Eventos</p>
            </div>
            <!-- Pedidos -->
            <div class="item-menu" (click)="activeTab(2, 'Pedidos'); toggleMenu()"
                [class.item-desactive]="!admin && !allowOrder && !allowSales"
                [routerLink]="['/panel-control/orders']" routerLinkActive="item-active"
                [routerLinkActiveOptions]="{exact:false}">
                <i class="fal fa-square-list pointer-in"></i>
                <p class="m-0">Pedidos</p>
            </div>
            <!-- Usuarios -->
            <div class="item-menu" (click)="activeTab(3, 'Usuarios'); toggleMenu()"
                [routerLink]="['/panel-control/subscribers']" routerLinkActive="item-active"
                [routerLinkActiveOptions]="{exact:false}" [class.item-desactive]="!admin && !allowMarketing">
                <i class="fal fa-user-group-simple pointer-in"></i>
                <p class="m-0">Usuarios</p>
            </div>
            <!-- Informes -->
            <div class="item-menu" (click)="activeTab(4, 'Informes'); toggleMenu()"
                [class.item-desactive]="!admin && !allowOrder && !allowSales"
                [routerLink]="['/panel-control/reports']" routerLinkActive="item-active"
                [routerLinkActiveOptions]="{exact:false}">
                <i class="fal fa-chart-line pointer-in"></i>
                <p class="m-0">Informes</p>
            </div>
            <!-- Descuentos -->
            <div class="item-menu" (click)="activeTab(5, 'Descuentos'); toggleMenu()"
                [class.item-desactive]="!admin && !allowOrder && !allowSales"
                [routerLink]="['/panel-control/discounts']" routerLinkActive="item-active"
                [routerLinkActiveOptions]="{exact:false}">
                <i class="fal fa-percent pointer-in"></i>
                <p class="m-0">Descuentos</p>
            </div>
            <!-- Abonos -->
            <div class="item-menu" (click)="activeTab(6, 'Abonos'); toggleMenu()"
                [class.item-desactive]="!admin && !allowSales"
                [routerLink]="['/panel-control/bonds']" routerLinkActive="item-active"
                [routerLinkActiveOptions]="{exact:false}">
                <i class="fal fa-layer-group pointer-in"></i>
                <p class="m-0">Abonos</p>
            </div>
            <!-- Abonos de temporada (módulo season_passes) -->
            <div class="item-menu" *ngIf="showSeasonPasses" (click)="activeTab(6, 'Abonos de temporada'); toggleMenu()"
                [class.item-desactive]="!admin && !allowSales"
                [routerLink]="['/panel-control/sports-passes']" routerLinkActive="item-active"
                [routerLinkActiveOptions]="{exact:false}">
                <i class="fal fa-id-card pointer-in"></i>
                <p class="m-0">Abonos de temporada</p>
            </div>
            <mat-divider style="margin: 6px 0;" *ngIf="showCashRegister"></mat-divider>
            <!-- Taquilla (módulo cash_register) -->
            <div class="item-menu" *ngIf="showCashRegister" (click)="openTicketOffice(); toggleMenu()" [class.item-desactive]="!admin && !allowSales">
                <i class="fal fa-ticket pointer-in"></i>
                <p class="m-0">Taquilla</p>
            </div>

            <!-- Sección Configuración (solo admin) -->
            <ng-container *ngIf="admin">
                <mat-divider style="margin: 6px 0;"></mat-divider>
                <!-- Configuración collapsible -->
                <div class="item-menu item-menu-org" (click)="toggleOrgSubmenu()" [class.item-active]="isOrgSubmenuExpanded">
                    <div class="item-menu-main">
                        <i class="fal fa-cog pointer-in"></i>
                        <p class="m-0">Configuración</p>
                    </div>
                    <i class="fal caret-icon"
                        [class.fa-angle-up]="isOrgSubmenuExpanded"
                        [class.fa-angle-down]="!isOrgSubmenuExpanded">
                    </i>
                </div>
                <ng-container *ngIf="isOrgSubmenuExpanded">
                    <div class="embedded-org-menu">
                        <div class="event-menu-container">
                            <!-- Mi perfil -->
                            <div class="item-submenu"
                                [routerLink]="['/panel-control/config/info-profile']"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: false }"
                                (click)="activeTab(5, 'Mi perfil'); toggleMenu()">
                                <i class="fal fa-user"></i>
                                <span>Mi perfil</span>
                            </div>
                            <!-- Organización -->
                            <div class="item-submenu"
                                [routerLink]="['/panel-control/config/business/info-business']"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: false }"
                                (click)="activeTab(5, 'Organización'); toggleMenu()">
                                <i class="fal fa-building-columns"></i>
                                <span>Organización</span>
                            </div>
                            <!-- Gestores -->
                            <div class="item-submenu"
                                [routerLink]="['/panel-control/config/permission/function']"
                                [queryParams]="{role: 'all'}"
                                [class.active]="showPermissionSubmenu"
                                (click)="activeTab(6, 'Gestores'); toggleMenu()">
                                <i class="fal fa-users-gear"></i>
                                <span>Gestores</span>
                            </div>
                            <!-- <ng-container *ngIf="showPermissionSubmenu">
                                <div class="embedded-submenu-mobile">
                                    <div class="item-submenu" [class.active]="currentPermissionRole === 'all'"
                                        [routerLink]="['/panel-control/config/permission/function']" [queryParams]="{role: 'all'}" (click)="toggleMenu()">
                                        <span>Todos</span>
                                    </div>
                                    <div class="item-submenu" *ngFor="let rol of permissionRoles"
                                        [class.active]="currentPermissionRole == rol.id"
                                        [routerLink]="['/panel-control/config/permission/function']" [queryParams]="{role: rol.id}" (click)="toggleMenu()">
                                        <span>{{rol.name}}</span>
                                    </div>
                                </div>
                            </ng-container> -->
                            <!-- Espacios -->
                            <div class="item-submenu"
                                [routerLink]="['/panel-control/config/venues']"
                                routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }"
                                (click)="activeTab(5, 'Espacios'); toggleMenu()">
                                <i class="fal fa-building"></i>
                                <span>Espacios</span>
                            </div>
                            <ng-container *ngIf="showVenueSubmenu && venueId">
                                <div class="embedded-submenu-mobile">
                                    <div class="item-submenu" [routerLink]="['/panel-control/config/venues/info-venue', venueId]" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="toggleMenu()"><span>Datos del espacio</span></div>
                                    <div class="item-submenu" [routerLink]="['/panel-control/config/venues/tickets-venue', venueId]" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" (click)="toggleMenu()"><span>Entradas base</span></div>
                                    <div class="item-submenu" *ngIf="venueMapVersion" [routerLink]="['/panel-control/config/venues/map-venue', venueId]" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}" [class.active]="isMapActive" (click)="toggleMenu()"><span>Mapa de butacas</span></div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </ng-container>
                <!-- Ayuda -->
                <div class="item-menu" (click)="activeTab(7, 'Ayuda'); toggleMenu()"
                    [routerLink]="['/panel-control/config/help']"
                    routerLinkActive="item-active"
                    [routerLinkActiveOptions]="{ exact: false }">
                    <i class="fal fa-circle-question pointer-in"></i>
                    <p class="m-0">Ayuda</p>
                </div>
            </ng-container>
        </div>
    </div>
</div>

<!-- Backdrop -->
<div class="offcanvas-backdrop fade" [class.show]="!isMenuCollapsed" (click)="toggleMenu()"></div>

<!--
<div class="menu-panel">
    <div class="logo-panel pointer-in" [routerLink]="['/']">
        <img fallimg src="assets/img/logo-panel.svg" alt="Citylok logo">
    </div>

    <div class="item-menu" [class.activeItem]="tabActive == 1" (click)="activeTab(1,'Eventos')"
        [routerLink]="['/panel/events']">
        <i class="fal fa-calendar-days icon-primary"></i>
        <p class="m-0">Eventos</p>
    </div>
    <div class="item-menu" [class.activeItem]="tabActive == 2" (click)="activeTab(2, 'Pedidos')"
        [routerLink]="['/panel/orders']">
        <i class="fal fa-square-list icon-primary"></i>
        <p class="m-0">Pedidos</p>
    </div>
    <div class="item-menu" [class.activeItem]="tabActive == 3" (click)="openVentas()"
        [class.disable-item]="!profile?.organizer">
        <i class="fal fa-ticket icon-primary"></i>
        <p class="m-0">Venta entradas</p>
    </div>
    <div class="item-menu disable-item" [class.activeItem]="tabActive == 4" (click)="activeTab(4, 'Informes')">
        <i class="fal fa-chart-line icon-primary"></i>
        <p class="m-0">Informes</p>
    </div>
    <div class="item-menu disable-item" [class.activeItem]="tabActive == 5" (click)="activeTab(5, 'Configuración')">
        <i class="fal fa-cog icon-primary"></i>
        <p class="m-0">Configuración</p>
    </div>
</div>
-->
